import  { useState, useEffect, useCallback,useMemo } from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { prism } from "react-syntax-highlighter/dist/esm/styles/prism";
import axios from "axios";
import loading from "../../assests/loading .gif";
import CustomTooltip from "../Buttons/CustomTooltip";

const transparentStyle = {
  ...prism,
  'code[class*="language-"]': {
    ...prism['code[class*="language-"]'],
    background: "transparent",
    color: "#333",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "21px",
    letterSpacing: "0%",
  },
  'pre[class*="language-"]': {
    ...prism['pre[class*="language-"]'],
    background: "transparent",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "21px",
    letterSpacing: "0%",
    padding: "5px",
    margin: 0,
  },
  // The base "prism" theme gives operators/entities/urls a translucent white
  // background, which shows up as an unwanted grey box behind characters
  // like "<", ">", "=" (especially noticeable in XML/SQL content).
  operator: { ...prism.operator, background: "transparent" },
  entity: { ...prism.entity, background: "transparent" },
  url: { ...prism.url, background: "transparent" },
  'input[type="checkbox"][data-is-parent="true"]:checked::after': {
    content: '"–"', // This is the hyphen character
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    fontSize: "12px",
    fontWeight: "bold",
    lineHeight: "1",
  },
};

function ViewConversation({
  conshow,
  consetShow,
  jobId,
  fileId,
  jobName,
  fileName,
  fileStatus,
}) {
  const [conversion, setConversion] = useState({
    raw_file_content: "",
    converted_file_content: "",
    converted_files: [],
    input_files: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [conversionExtension, setconversionExtension] = useState({
    raw_file_extension: "",
    converted_file_extension: "",
  });
  const [dbName, setdbName] = useState({ source_db: "", target_db: "" });
  const [showTargetDropdown, setShowTargetDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [checkedItems, setCheckedItems] = useState({});
  const [expandedItems, setExpandedItems] = useState({});
  const [selectedFileContent, setSelectedFileContent] = useState("");
  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [foldersData, setFoldersData] = useState(null);
  const [fileLoading, setFileLoading] = useState(false);
  const [forcedTargetFilename, setForcedTargetFilename] = useState("");
  const [copiedStates, setCopiedStates] = useState({
    source: false,
    target: false,
  });
  const isStructuredConversion = useMemo(() => {
    const source = dbName.source_db?.toLowerCase();
    const target = dbName.target_db?.toLowerCase();

    const sourceIsInformatica = source === "informatica";
    const sourceIsDbtOnly =
      source === "oracle stored procedure" ||
      source === "snowflake" ||
      source === "sql server stored procedure" ||
      source === "ms sql server" ||
      source === "ssis" ||
      source === "oracle t-sql";

    const isInputStructured = source === "dbt" && target === "aws glue";
    const isOutputStructured =
      (sourceIsInformatica &&
        ["dbt", "spark sql", "ssis", "coalesce"].includes(target)) ||
      (sourceIsDbtOnly && ["dbt", "coalesce"].includes(target));

    return isInputStructured || isOutputStructured;
  }, [dbName.source_db, dbName.target_db]);


  const getSyntaxHighlighterLanguage = useCallback(
    (extension, dbType) => {
      // If we have explicit dbType information, use that first
      if (dbType) {
        const dbLower = dbType.toLowerCase();
        if (dbLower.includes("dbt")) return "sql";
         if (dbLower.includes("coalesce")) return "yaml";
        if (dbLower.includes("spark sql")) return "sql";
        if (dbLower.includes("pyspark")) return "python";
        if (dbLower.includes("informatica")) return "xml";
        // SSIS packages (.dtsx) are XML-based
        if (dbLower.includes("ssis")) return "xml";
      }

      // Extension may come in as a string ("xml"/".xml") or, for multi-extension
      // targets (e.g. SSIS: [".xml", ".dtsx"]), as an array - normalize to a string first.
      const rawExtension = Array.isArray(extension) ? extension[0] : extension;
      const ext = String(rawExtension || "")
        .toLowerCase()
        .replace(".", "");
      const languageMap = {
        sql: "sql",
        py: "python",
        xml: "xml",
        dtsx: "xml",
        json: "json",
        yaml: "yml",
        yml: "yml",
        txt: "text",
   
      };
      return languageMap[ext] || "sql";
    },
    []
  );
  const SourceCodeDisplay = useMemo(
    () => (
      <SyntaxHighlighter
        language={getSyntaxHighlighterLanguage(
          conversionExtension.raw_file_extension,
          dbName.source_db
        )}
        style={transparentStyle}
        wrapLines={false}
      >
        {conversion.raw_file_content ||
          (dbName.source_db?.toLowerCase() === "dbt" &&
          dbName.target_db?.toLowerCase() === "aws glue"
            ? "Select a file from the dropdown menu above to view its content"
            : fileStatus === "In Progress"
            ? "Code conversion is currently In Progress"
            : "Input file content is not available.")}
      </SyntaxHighlighter>
    ),
    [
      conversion.raw_file_content,
      conversionExtension.raw_file_extension,
      dbName.source_db,
      dbName.target_db,
      fileStatus,
    ]
  );
  useEffect(() => {
    if (dbName.target_db) {
      // For Many-to-One (dbt to Glue), use the actual converted filename if available
      if (
        dbName.source_db?.toLowerCase() === "dbt" &&
        dbName.target_db?.toLowerCase() === "aws glue"
      ) {
        const outputName =
          conversion.converted_files?.[0]?.files?.[0]?.converted_file_name;
        if (outputName) {
          setForcedTargetFilename(outputName);
          return;
        }
      }

      const baseName = (selectedFileName || fileName || "converted").replace(
        /\.[^/.]+$/,
        ""
      );
      const newExtension = getTargetExtension(dbName.target_db);
      setForcedTargetFilename(`${baseName}.${newExtension}`);
    }
  }, [
    selectedFileName,
    fileName,
    dbName.target_db,
    dbName.source_db,
    conversion.converted_files,
  ]);

  useEffect(() => {
    console.log("UI Display Value:", forcedTargetFilename);
    console.log("Source Data:", {
      selectedFileName,
      fileName,
      targetDb: dbName.target_db,
    });
  }, [forcedTargetFilename]);
  const getTargetExtension = (targetDb) => {
    if (!targetDb) return "txt";

    const dbLower = targetDb.toLowerCase();

    // Explicit mapping
    if (dbLower.includes("pyspark")) return "py";
    if (dbLower.includes("spark")) return "sql"; // For Spark SQL
     if (dbLower.includes("coalesce")) return "yml"; // For Spark SQL
    if (dbLower.includes("dbt") || dbLower.includes("sql")) return "sql";

    return "sql";
  };
  const shouldShowSearchDropdown = useMemo(() => {
    const source = dbName.source_db?.toLowerCase();
    const target = dbName.target_db?.toLowerCase();

    const sourceIsInformatica = source === "informatica";
    const sourceIsSQLServer =
      source === "sql server stored procedure" || source === "ms sql server";
    const sourceIsDbtOnly =
      source === "oracle stored procedure" ||
      source === "snowflake" ||
      source === "ms sql server" ||
      source === "ssis" ||
      source === "oracle t-sql";

    const isInputStructured = source === "dbt" && target === "aws glue";
    const isOutputStructured =
      (sourceIsInformatica && ["dbt", "spark sql", "ssis"].includes(target)) ||
      (sourceIsSQLServer && ["dbt", "coalesce"].includes(target)) ||
      (sourceIsDbtOnly && target === "dbt");

    return isInputStructured || isOutputStructured;
  }, [dbName.source_db, dbName.target_db]);


  const fileExtensionMapper = {
    Snowflake: "sql",
    "Oracle T-SQL": "sql",
    "DBT Redshift": "sql",
    "Snowflake Openflow": "json",
    Informatica: "xml",
    "Informatica BDM": "xml",
    PySpark: "py",
    "Spark SQL": "sql",
    "DBT Databricks": "sql",
    dbt: "sql",
    "Oracle Stored Procedure": "sql",
    PostgreSQL: "sql",
    Databricks: "sql",
    "SQL Server Stored Procedure": "sql",
    "MS SQL Server": "sql",
    "IBM Datastage": "xml",
    SSIS: [".xml", ".dtsx"],
    SAS: [".sas",".flw",".txt"],
    coalesce:"yml",
    Netezza: "sql",
    "Starburst SQL": "sql",
    "AWS Athena": "sql",
  };

  const targetFileExtension = fileExtensionMapper[dbName.target_db];

  const fetchConvertedContent = async (jobId, fileName) => {
     const apiBaseconvert = process.env.REACT_APP_API_URL_CODE_CONVERSION;
    try {
      setFileLoading(true);
      const authToken = sessionStorage.getItem("access_token");
      const response = await axios.get(
        `${apiBaseconvert}/converted_content/${jobId}?file_name=${fileName}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: "application/json",
          },
        }
      );

      if (response.data && response.data.file_content) {
        return response.data.file_content;
      }
      return "";
    } catch (error) {
      console.error("Error fetching converted content:", error);
      return "";
    } finally {
      setFileLoading(false);
    }
  };

  const handleCheckboxChange = async (
    item,
    parentItems = [],
    fileName = "",
    isFile = false,
    fileId = null
  ) => {
    if (isFile) {
      setCheckedItems((prev) => {
        const newState = { ...prev };

        // If this file is already checked, uncheck it
        if (prev[item]) {
          newState[item] = false;
          setSelectedFileContent("");
          setSelectedFileName("");
          setSelectedFileId(null);
          return newState;
        }

        // If we're checking the file (not unchecking)
        // First uncheck all other files
        Object.keys(prev).forEach((key) => {
          if (
            prev[key] &&
            documents.some((doc) => {
              // Check if this key is a file (not a folder)
              const isFileKey = (node) => {
                if (node.id === key && node.type === "file") return true;
                if (node.children) {
                  return node.children.some(isFileKey);
                }
                return false;
              };
              return isFileKey(doc);
            })
          ) {
            newState[key] = false;
          }
        });

        // Check the current file
        newState[item] = true;

        return newState;
      });

      // Only fetch content if we're checking the file, not unchecking
      if (!checkedItems[item]) {
        // dbt -> AWS Glue is the only "many inputs combine into one output"
        // case: many dbt files feed a single Glue script, so picking a
        // dropdown item there really does mean "show a different input".
        // Every other case handled by this dropdown (including the
        // one-input-to-many-outputs structured conversions, e.g. SQL
        // Server Stored Procedure/Informatica -> dbt/Coalesce/Spark SQL)
        // has exactly one input file for the whole panel, already loaded
        // when it opened - picking a different *output* file must never
        // touch/replace the left (raw) panel.
        const isManyInputsSingleOutput =
          dbName.source_db?.toLowerCase() === "dbt" &&
          dbName.target_db?.toLowerCase() === "aws glue";

        if (isManyInputsSingleOutput) {
          let sourceContent = "";
          const parts = item.split("-");
          if (parts[0] === "file") {
            const mIdx = parseInt(parts[1]);
            const fIdx = parseInt(parts[2]);
            sourceContent =
              conversion.input_files[mIdx]?.files[fIdx]?.file_content || "";
          }

          if (sourceContent) {
            setConversion((prev) => ({
              ...prev,
              raw_file_content: sourceContent,
            }));
          } else {
            // Fallback to API if not found in state
            const fetchedContent = await fetchFileContent(fileId || item);
            setConversion((prev) => ({
              ...prev,
              raw_file_content: fetchedContent,
            }));
          }
        }

        // Fetch target content
        const content = await fetchConvertedContent(jobId, fileName);
        if (
          !content &&
          dbName.source_db?.toLowerCase() === "dbt" &&
          dbName.target_db?.toLowerCase() === "aws glue"
        ) {
          // Fallback to the first converted file if no direct mapping exists
          const fallback =
            conversion.converted_files?.[0]?.files?.[0]
              ?.converted_file_content;
          setSelectedFileContent(fallback || "");
        } else {
          setSelectedFileContent(content);
        }
        setSelectedFileName(fileName);
        setSelectedFileId(fileId || item);
      }

      setTimeout(() => {
        setShowTargetDropdown(false);
      }, 1000);
    }
  };

  const handleExpandToggle = (item) => {
    setExpandedItems((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };
  const handleCopy = async (type, text) => {
    try {
      // Check if Clipboard API is available
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback for browsers without Clipboard API
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      setCopiedStates((prev) => ({
        ...prev,
        [type]: true,
      }));

      setTimeout(() => {
        setCopiedStates((prev) => ({
          ...prev,
          [type]: false,
        }));
      }, 1000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
      // Optionally show an error message to the user
    }
  };
  const handleconClose = () => consetShow(false);

  const fetchFileContent = async (fileId) => {
     const apiBaseFile = process.env.REACT_APP_API_URL_CODE_CONVERSION;
    try {
      const authToken = sessionStorage.getItem("access_token");
      const response = await axios.get(
       `${apiBaseFile}/file_content/${jobId}?file_id=${fileId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: "application/json",
          },
        }
      );

      if (response.data && response.data.length > 0) {
        return response.data[0].converted_file_content;
      }
      return "";
    } catch (error) {
      console.error("Error fetching file content:", error);
      return "";
    }
  };

  // Updated to handle the new API response structure
const convertToDocumentStructure = (convertedFiles) => {
  if (
    !convertedFiles ||
    !Array.isArray(convertedFiles) ||
    convertedFiles.length === 0
  )
    return [];
  
  const isSQLServerToCoalesce = 
    (dbName.source_db?.toLowerCase() === "sql server stored procedure" || 
     dbName.source_db?.toLowerCase() === "ms sql server") && 
    dbName.target_db?.toLowerCase() === "coalesce";

  return convertedFiles.map((mainFolder, mainIndex) => {
    const mainFolderId = `main-folder-${mainIndex}`;

    // Main folder object
    const mainFolderObj = {
      id: mainFolderId,
      name: mainFolder.main_folder || `Main Folder ${mainIndex}`,
      type: "main-folder",
      children: [],
    };

    // Handle files directly under main folder
    if (mainFolder.files && Array.isArray(mainFolder.files)) {
      mainFolderObj.children = [
        ...mainFolderObj.children,
        ...mainFolder.files.map((file, fileIndex) => ({
          id: `file-${mainIndex}-${fileIndex}`,
          name:
            file.file_name || file.converted_file_name || `File ${fileIndex}`,
          type: "file",
          extension: file.file_extension || file.converted_file_extension,
          fileId: file.file_id,
          fullPath: file.file_path || file.converted_file_name || file.file_name,
          children: [],
        })),
      ];
    }

    if (mainFolder.child_folders && Array.isArray(mainFolder.child_folders)) {
      mainFolderObj.children = mainFolder.child_folders.reduce(
        (acc, childFolder, childIndex) => {
          if (!childFolder.child_folder) {
            // Handle files directly under main folder
            if (childFolder.files && Array.isArray(childFolder.files)) {
              const files = childFolder.files.map((file, fileIndex) => ({
                id: `file-${mainIndex}-${fileIndex}`,
                name: file.converted_file_name || `File ${fileIndex}`,
                type: "file",
                extension: file.converted_file_extension,
                fileId: file.file_id,
                fullPath: file.converted_file_path || file.converted_file_name,
                children: [],
              }));
              return [...acc, ...files];
            }
            return acc;
          }

          const childFolderId = `child-folder-${mainIndex}-${childIndex}`;

          // For SQL Server → Coalesce, extract just the last part of the folder path
          let folderName = childFolder.child_folder;
          if (isSQLServerToCoalesce) {
            const parts = folderName.split('/');
            folderName = parts[parts.length - 1]; // Get the last part
          }

          const childFolderObj = {
            id: childFolderId,
            name: folderName,
            type: "child-folder",
            fullPath: childFolder.child_folder,
            children: [],
          };

          // Handle files in child folders
          if (childFolder.files && Array.isArray(childFolder.files)) {
            childFolderObj.children = childFolder.files.map(
              (file, fileIndex) => ({
                id: `file-${mainIndex}-${childIndex}-${fileIndex}`,
                name: file.converted_file_name || `File ${fileIndex}`,
                type: "file",
                extension: file.converted_file_extension,
                fileId: file.file_id,
                fullPath: file.converted_file_path || file.converted_file_name,
                children: [],
              })
            );
          }

          // Handle nested child folders (if any)
          if (childFolder.child_folders && Array.isArray(childFolder.child_folders)) {
            childFolderObj.children = [
              ...childFolderObj.children,
              ...childFolder.child_folders.map((nestedFolder, nestedIndex) => ({
                id: `nested-folder-${mainIndex}-${childIndex}-${nestedIndex}`,
                name: nestedFolder.child_folder,
                type: "child-folder",
                fullPath: nestedFolder.child_folder,
                children: nestedFolder.files ? nestedFolder.files.map((file, fileIndex) => ({
                  id: `file-${mainIndex}-${childIndex}-${nestedIndex}-${fileIndex}`,
                  name: file.converted_file_name,
                  type: "file",
                  extension: file.converted_file_extension,
                  fileId: file.file_id,
                  fullPath: file.converted_file_path || file.converted_file_name,
                  children: [],
                })) : [],
              }))
            ];
          }

          return [...acc, childFolderObj];
        },
        []
      );
    }

    return mainFolderObj;
  });
};

  const getDatabaseImagePath = useCallback((dbName) => {
    if (!dbName) return "assets/images/default.png";
    const normalized = dbName.toLowerCase().replace(/\s+/g, "-");
    return `assets/images/${normalized}.png`;
  }, []);

  const documents = foldersData
    ? convertToDocumentStructure(foldersData)
    : convertToDocumentStructure(
        dbName.source_db?.toLowerCase() === "dbt" &&
          dbName.target_db?.toLowerCase() === "aws glue"
          ? conversion.input_files
          : conversion.converted_files
      );

  const filteredDocuments = documents.filter(
    (doc) =>
      doc.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (doc.children &&
        doc.children.some(
          (child) =>
            child.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (child.children &&
              child.children.some((file) =>
                file.name.toLowerCase().includes(searchTerm.toLowerCase())
              ))
        ))
  );

  const renderDocumentItem = (
    doc,
    level = 0,
    parentItems = [],
    isLastChild = false
  ) => {
    const hasChildren = doc.children && doc.children.length > 0;
    const isExpanded = expandedItems[doc.id];

    // Skip rendering if it's the main folder with index 0
    if (doc.name === "Main Folder 0") {
      return null;
    }

    return (
      <div key={doc.id} className="mb-1 position-relative">
        <div
          className="d-flex align-items-center"
          style={{
            marginLeft: `${level * 15}px`,
            position: "relative",
            paddingLeft: level > 0 ? "1px" : "0",
          }}
        >
          {level > 0 && (
            <div
              style={{
                position: "absolute",
                left: "0",
                top: "0",
                bottom: "50%",
                width: "0px",
                backgroundColor: "#888",
                zIndex: 1,
              }}
            ></div>
          )}

          {level > 0 && !hasChildren && (
            <div
              style={{
                position: "absolute",
                left: "0",
                top: "12%",
                height: "12px",
                width: "12px",
                borderLeft: "1px solid #888",
                borderBottom: "1px solid #888",
                borderBottomLeftRadius: "6px",
                zIndex: 1,
              }}
            ></div>
          )}

          {hasChildren ? (
            <i
              className={`fas fa-chevron-${
                isExpanded ? "down" : "right"
              } me-2 cursor-pointer`}
              style={{
                fontSize: "10px",
                color: "#888",
                marginLeft: level > 0 ? "-2px" : "0",
                flexShrink: 0,
              }}
              onClick={() => handleExpandToggle(doc.id)}
            />
          ) : (
            <span
              style={{
                width: "10px",
                display: "inline-block",
                marginRight: "8px",
              }}
            ></span>
          )}

          {doc.type === "file" && (
            <input
              type="checkbox"
              className="form-check-input me-2"
              id={`doc-${doc.id}`}
              checked={!!checkedItems[doc.id]}
              onChange={async () => {
                await handleCheckboxChange(
                  doc.id,
                  parentItems,
                  doc.name,
                  true,
                  doc.fileId
                );
              }}
              style={{
                marginTop: "0",
                cursor: "pointer",
                color: "white",
                width: "14px",
                height: "14px",
                boxShadow: "none",
                flexShrink: 0,
              }}
            />
          )}

          <label
            htmlFor={`doc-${doc.id}`}
            className="font-size-12 d-flex align-items-center"
            title={doc.fullPath}
            style={{
              cursor: doc.type !== "file" ? "pointer" : "default",
              userSelect: "none",
              paddingTop: "8px",
              whiteSpace: "nowrap",
              overflow: "visible",
              flexGrow: 1,
              minWidth: 0,
            }}
            onClick={(e) => {
              if (doc.type !== "file") {
                e.preventDefault();
                handleExpandToggle(doc.id);
              }
            }}
          >
            {doc.type === "main-folder" && (
              <i className="far fa-folder-open me-2"></i>
            )}
            {doc.type === "child-folder" && (
              <i className="far fa-folder me-2"></i>
            )}
            {doc.type === "file" && <i className="far fa-file-code me-2"></i>}
            <span
              style={{
                overflow: "visible",
                textOverflow: "clip",
              }}
            >
              {doc.name}
            </span>
          </label>
        </div>

        {hasChildren && isExpanded && (
          <div
            style={{
              position: "relative",
              marginLeft: `${level * 15 + 10}px`,
            }}
          >
            <div
              style={{
                position: "absolute",
                left: "-6px",
                top: "0",
                bottom: "0",
                width: "1px",
                backgroundColor: "#888",
                zIndex: 1,
              }}
            ></div>

            {doc.children.map((child, index) =>
              renderDocumentItem(
                child,
                level + 1,
                [...parentItems, doc.id],
                index === doc.children.length - 1
              )
            )}
          </div>
        )}
      </div>
    );
  };
  // This must stay in sync with the backend's allow-list in
  // get_folder_structure (services/migration_jobs.py) - that endpoint is
  // what actually populates the raw input file content for these
  // one-input-to-many-output conversions. If a combo is allowed on the
  // backend but missing here, we silently skip fetching /folders and the
  // left panel falls back to a generic "in progress" message even for a
  // completed job, since conversion.raw_file_content never gets populated.
  const isStructuredConversionAllowed = (source, target) => {
    if (!source || !target) return false;

    source = source.toLowerCase();
    target = target.toLowerCase();

    const allowedDbtSources = [
      "informatica",
      "snowflake",
      "oracle t-sql",
      "oracle stored procedure",
      "sql server stored procedure",
      "ssis",
      "ms sql server",
    ];
    const allowedCoalesceSources = ["ms sql server", "sql server stored procedure"];

    if (allowedDbtSources.includes(source) && target === "dbt") return true;
    if (source === "informatica" && target === "spark sql") return true;
    if (source === "informatica" && target === "ssis") return true;
    if (allowedCoalesceSources.includes(source) && target === "coalesce") return true;

    return false;
  };


  useEffect(() => {
    if (!jobId) {
      console.error("jobId is missing.");
      return;
    }

    let isMounted = true;
    const abortController = new AbortController();

    const fetchConversion = async () => {
      const apiBaseConversion = process.env.REACT_APP_API_URL_CODE_CONVERSION;
      setIsLoading(true);

      try {
        const authToken = sessionStorage.getItem("access_token");
        if (!authToken) {
          console.error("Authentication token is missing.");
          return;
        }

        // First fetch the database names
        const initialUrl = fileId
          ? `${apiBaseConversion}/file_content/${jobId}?file_id=${fileId}`
          : `${apiBaseConversion}/file_content/${jobId}`;

        const initialResponse = await axios.get(initialUrl, {
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: "application/json",
          },
        });

        let apiData = Array.isArray(initialResponse.data)
          ? initialResponse.data[0]
          : initialResponse.data;

        setdbName({
          source_db: apiData?.source_db || "Source Database",
          target_db: apiData?.target_db || "Target Database",
        });
        // Check if we need to fetch the folders data
      if (isStructuredConversionAllowed(apiData?.source_db, apiData?.target_db))

        {
          // Fetch folders data
          const foldersResponse = await axios.get(
            `${apiBaseConversion}/folders/${jobId}?file_id=${fileId}`,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
                Accept: "application/json",
              },
            }
          );

          if (foldersResponse.data && foldersResponse.data.length > 0) {
            setFoldersData(foldersResponse.data);
            setConversion((prev) => ({
              ...prev,
              raw_file_content: foldersResponse.data[0]?.raw_file_content || "",
              converted_files: apiData?.converted_files || [],
            }));
          }
        } else {
          // Use the regular data
          setConversion({
            raw_file_content: apiData?.raw_file_content || "",
            converted_file_content: apiData?.converted_file_content || "",
            converted_files: apiData?.converted_files || [],
            input_files: apiData?.input_files || [],
          });

          // For dbt to Glue, auto-select the first converted file to show on the right side
          if (
            apiData?.source_db?.toLowerCase() === "dbt" &&
            apiData?.target_db?.toLowerCase() === "aws glue"
          ) {
            const firstConvertedFile = apiData?.converted_files?.[0]?.files?.[0];
            if (firstConvertedFile) {
              setSelectedFileContent(firstConvertedFile.converted_file_content);
              setconversionExtension((prev) => ({
                ...prev,
                converted_file_extension: firstConvertedFile.converted_file_extension || "py",
              }));
            }
          }

          setconversionExtension({
            raw_file_extension: apiData?.raw_file_extension || "txt",
            converted_file_extension:
              apiData?.converted_file_extension || "txt",
          });

          if (fileId && apiData?.converted_file_content) {
            setSelectedFileContent(apiData.converted_file_content);
            setSelectedFileName(fileName);
            setSelectedFileId(`initial-${fileId}`);
            setCheckedItems({ [`initial-${fileId}`]: true });
          }
        }
      } catch (error) {
        console.error("Error fetching conversion:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchConversion();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, [jobId, fileId]);

  return (
    <div
      className={`right-bar4 p-3 ${conshow ? "d-block" : "d-none"}`}
      style={{ overflow: "hidden" }}
    >
      <div className="h-100 d-flex flex-column" style={{ overflow: "hidden" }}>
        <div
          className="d-flex align-items-center justify-content-between mb-3 "
          style={{ marginTop: "3.5px" }}
        >
          <h6 className="mb-0 fw-medium text-dark">Translate</h6>

          <CustomTooltip
            content="Close"
            placement="left"
            fallbackPlacements={["top-end", "top"]}
            offset={[-10, 0]}
            delayShow={200}
          >
            <i
              onClick={handleconClose}
              className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor"
            />
          </CustomTooltip>
        </div>

        <div className="trace-label p-2 pe-3 d-flex align-items-center mb-3 w-fit-content">
          <img
            src="/assets/images/trace_label.png"
            className="w-14px me-2"
            alt="Job icon"
          />
          <h6 className="font-size-10 mb-0 text-dark">{jobName}</h6>
        </div>

        <div className="mb-3">
          <h6 className="text-dark fw-bold font-size-12 mb-2">
            Selected Document
          </h6>
          {isLoading ? (
            <div className="row g-2">
              <div className="col-md-6">
                <div>
                  <div
                    className="loadingStyle col-12 rounded-2"
                    style={{ height: "20px", marginBottom: "8px" }}
                  ></div>
                  <div
                    className="loadingStyle col-12 rounded-2"
                    style={{ height: "40px" }}
                  ></div>
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <div
                    className="loadingStyle col-12 rounded-2"
                    style={{ height: "20px", marginBottom: "8px" }}
                  ></div>
                  <div
                    className="loadingStyle col-12 rounded-2"
                    style={{ height: "40px" }}
                  ></div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row g-2">
              <div className="col-md-6 position-relative">
                <div className="font-size-12 text-secondary mb-1 text-truncate">
                  {dbName.source_db?.toLowerCase() === "dbt" &&
                  dbName.target_db?.toLowerCase() === "aws glue"
                    ? selectedFileName || fileName
                    : fileName}
                </div>
                <div
                  className={`d-flex align-items-center bg-white rounded-2 p-2 border ${
                    dbName.source_db?.toLowerCase() === "dbt" &&
                    dbName.target_db?.toLowerCase() === "aws glue"
                      ? "cursor-pointer"
                      : ""
                  }`}
                  onClick={() => {
                    if (
                      dbName.source_db?.toLowerCase() === "dbt" &&
                      dbName.target_db?.toLowerCase() === "aws glue"
                    ) {
                      setShowTargetDropdown(!showTargetDropdown);
                    }
                  }}
                  style={{ height: "41px" }}
                >
                  {dbName.source_db && (
                    <img
                      src={
                        getDatabaseImagePath(dbName.source_db) ||
                        "/placeholder.svg"
                      }
                      onError={(e) => {
                        console.error("Failed to load image:", e.target.src);
                        e.target.src = getDatabaseImagePath(
                          dbName.source_db
                        ).replace(".png", ".jpg");
                      }}
                      alt={dbName.source_db}
                      className="me-2"
                      style={{
                        width: "43px",
                        height: "23px",
                        objectFit: "contain",
                      }}
                    />
                  )}
                  <span className="text-truncate flex-grow-1">
                    {dbName.source_db}
                  </span>
                  {dbName.source_db?.toLowerCase() === "dbt" &&
                    dbName.target_db?.toLowerCase() === "aws glue" && (
                      <i
                        className={`fas fa-chevron-${
                          showTargetDropdown ? "up" : "down"
                        } ms-2`}
                      ></i>
                    )}
                </div>

                {dbName.source_db?.toLowerCase() === "dbt" &&
                  dbName.target_db?.toLowerCase() === "aws glue" &&
                  showTargetDropdown && (
                    <div
                      className="position-absolute top-100 end-0 mt-1 w-100 bg-white border rounded shadow-sm p-2 z-3"
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        position: "absolute",
                        zIndex: 1000,
                      }}
                    >
                      <div className="search-bar my-2 position-relative">
                        <span
                          className="ri-search-line position-absolute"
                          style={{
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            fontSize: "16px",
                          }}
                        ></span>
                        <input
                          type="text"
                          placeholder="Search input files..."
                          className="form-control highlighted-input font-size-12 doc-search text-d-search pr-5 colorfor-placeholder styled-input"
                          style={{ paddingLeft: "30px", width: "100%" }}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="document-list ps-2">
                        {filteredDocuments.length > 0 ? (
                          filteredDocuments.map((doc) =>
                            renderDocumentItem(doc)
                          )
                        ) : (
                          <div className="text-center py-2 text-muted small">
                            No matching input files found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
              </div>

              <div className="col-md-6 position-relative">
                <div
                  className="font-size-12 text-secondary mb-1 text-truncate"
                  style={{
                    minHeight: "20px",
                    lineHeight: "20px",
                    marginBottom: "8px",
                  }}
                >
                  {isLoading ? (
                    <div
                      className="skeleton-loader"
                      style={{
                        width: "150px",
                        height: "14px",
                        display: "inline-block",
                      }}
                    ></div>
                  ) : (
                    forcedTargetFilename || (
                      <span className="text-muted">Loading filename...</span>
                    )
                  )}
                </div>
                <div
                  className={`d-flex align-items-center bg-white rounded-2 p-2 border ${
                    dbName.source_db?.toLowerCase() !== "dbt" ||
                    dbName.target_db?.toLowerCase() !== "aws glue"
                      ? "cursor-pointer"
                      : ""
                  }`}
                  onClick={() => {
                    if (
                      dbName.source_db?.toLowerCase() !== "dbt" ||
                      dbName.target_db?.toLowerCase() !== "aws glue"
                    ) {
                      setShowTargetDropdown(!showTargetDropdown);
                    }
                  }}
                  style={{
                    height: "41px",
                    marginTop: "-2px",
                  }}
                >
                  {isLoading ? (
                    <div className="d-flex align-items-center w-100 gap-2">
                      <div
                        className="skeleton-loader"
                        style={{ width: "43px", height: "23px" }}
                      ></div>
                      <div
                        className="skeleton-loader flex-grow-1"
                        style={{ height: "16px" }}
                      ></div>
                    </div>
                  ) : (
                    <>
                      {dbName.target_db && (
                        <img
                          src={
                            getDatabaseImagePath(dbName.target_db) ||
                            "/placeholder.svg"
                          }
                          onError={(e) => {
                            console.error(
                              "Failed to load image:",
                              e.target.src
                            );
                            e.target.src = getDatabaseImagePath(
                              dbName.target_db
                            ).replace(".png", ".jpg");
                          }}
                          alt={dbName.target_db}
                          className="me-2"
                          style={{
                            width: "43px",
                            height: "23px",
                            objectFit: "contain",
                            flexShrink: 0,
                          }}
                        />
                      )}
                      <span className="text-truncate flex-grow-1">
                        {dbName.target_db}
                      </span>
                      {dbName.source_db?.toLowerCase() !== "dbt" ||
                      dbName.target_db?.toLowerCase() !== "aws glue" ? (
                        shouldShowSearchDropdown && (
                          <i
                            className={`fas fa-chevron-${
                              showTargetDropdown ? "up" : "down"
                            } ms-2`}
                          ></i>
                        )
                      ) : null}
                    </>
                  )}
                </div>

                {shouldShowSearchDropdown &&
                  showTargetDropdown &&
                  (dbName.source_db?.toLowerCase() !== "dbt" ||
                    dbName.target_db?.toLowerCase() !== "aws glue") && (
                    <div
                      className="position-absolute top-100 end-0 mt-1 w-100 bg-white border rounded shadow-sm p-2 z-3"
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        position: "absolute",
                        zIndex: 1000,
                      }}
                    >
                      <div className="search-bar my-2 position-relative">
                        <span
                          className="ri-search-line position-absolute"
                          style={{
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            fontSize: "16px",
                          }}
                        ></span>
                        <input
                          type="text"
                          placeholder="Search converted files..."
                          className="form-control highlighted-input font-size-12 doc-search text-d-search pr-5 colorfor-placeholder styled-input"
                          style={{ paddingLeft: "30px", width: "100%" }}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>

                      <div
                        className="document-list ps-2"
                        style={{
                          position: "relative",
                          minHeight: "50px",
                        }}
                      >
                        {filteredDocuments.length > 0 ? (
                          filteredDocuments.map((doc) =>
                            renderDocumentItem(doc)
                          )
                        ) : (
                          <div className="text-center py-2 text-muted small">
                            No matching documents found
                          </div>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          )}
        </div>

        <div
          className="flex-grow-1 d-flex flex-column"
          style={{ overflow: "hidden" }}
        >
          <h6 className="text-dark font-size-12 mb-2">Translation Result</h6>
          {isLoading ? (
            <div className="row g-2 flex-grow-1">
              <div className="col-md-6 h-100">
                <div className="loadingStyle h-100 rounded-2"></div>
              </div>
              <div className="col-md-6 h-100">
                <div className="loadingStyle h-100 rounded-2"></div>
              </div>
            </div>
          ) : (
            <div
              className="row g-2 flex-grow-1 viewcon-mob-res"
              style={{ minHeight: 0 }}
            >
              <div className="col-md-6 h-100 d-flex flex-column">
                <div
                  className="p-2 translation-result-box border rounded-2 position-relative"
                  style={{
                    overflow: "auto",
                    scrollbarWidth: "thin",
                    height: "55vh",
                    scrollbarColor: "#ddd #f5f5f5",
                  }}
                >
                  {/* Add this button */}
                  <button
                    onClick={() =>
                      handleCopy("source", conversion.raw_file_content)
                    }
                    className="btn btn-sm position-absolute end-0 top-0 m-1"
                    style={{
                      zIndex: 1,
                      backgroundColor: copiedStates.source
                        ? "#f8f9fa"
                        : "#f8f9fa",
                      color: copiedStates.source ? "#6c757d" : "#6c757d",
                      border: 0,
                      fontSize: "12px",
                      padding: "2px 8px",
                      // transition: 'all 0.3s ease'
                    }}
                  >
                    {copiedStates.source ? (
                      <>
                        <i className="fas fa-check me-1"></i> Copied!
                      </>
                    ) : (
                      <>
                        <i className="far fa-copy me-1"></i> Copy
                      </>
                    )}
                  </button>
                  <br />

                  <div
                    style={{
                      overflow: "auto",
                      scrollbarWidth: "thin",
                      scrollbarColor: "#ddd #f5f5f5",
                    }}
                  >
                    <div style={{ minWidth: "fit-content" }}>
                      {SourceCodeDisplay}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 h-100 d-flex flex-column">
                <div
                  className="p-2 translation-result-box border rounded-2 position-relative"
                  style={{
                    overflow: "auto",
                    scrollbarWidth: "thin",
                    height: "55vh",
                    scrollbarColor: "#ddd #f5f5f5",
                  }}
                >
                  {fileLoading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                      <img
                        src={loading}
                        alt="Loading..."
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  ) : (
                    <>
                      {/* Add this button */}
                      <button
                        onClick={() =>
                          handleCopy(
                            "target",
                            selectedFileContent ||
                              conversion.converted_file_content
                          )
                        }
                        className="btn btn-sm position-absolute end-0 top-0 m-1"
                        style={{
                          zIndex: 1,
                          backgroundColor: copiedStates.source
                            ? "#f8f9fa"
                            : "#f8f9fa",
                          color: copiedStates.source ? "#6c757d" : "#6c757d",
                          border: 0,
                          fontSize: "12px",
                          padding: "2px 8px",
                          transition: "all 0.3s ease",
                        }}
                        disabled={
                          !selectedFileContent &&
                          !conversion.converted_file_content
                        }
                      >
                        {copiedStates.target ? (
                          <>
                            <i className="fas fa-check me-1"></i> Copied!
                          </>
                        ) : (
                          <>
                            <i className="far fa-copy me-1"></i> Copy
                          </>
                        )}
                      </button>
                      <br />
                      <div
                        style={{
                          overflow: "auto",
                          scrollbarWidth: "thin",
                          scrollbarColor: "#ddd #f5f5f5",
                        }}
                      >
                        <div style={{ minWidth: "fit-content" }}>
                          {selectedFileContent ||
                          conversion.converted_file_content ? (
                            <SyntaxHighlighter
                              language={getSyntaxHighlighterLanguage(
                                targetFileExtension,
                                dbName.target_db
                              )}
                              style={transparentStyle}
                              wrapLines={false}
                            >
                              {selectedFileContent ||
                                conversion.converted_file_content}
                            </SyntaxHighlighter>
                          ) : (
                            <div className="font-size-12 text-muted">
                              {fileStatus === "In Progress"
                                ? `Code conversion is currently ${fileStatus}`
                                : isStructuredConversion &&
                                  !selectedFileContent &&
                                  fileStatus === "Completed"
                                ? "Select a file from the dropdown menu above to view its content"
                                : "Code conversion was unsuccessful. Please check the logs for more details."}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-3 text-start">
          <button
            onClick={handleconClose}
            className="btn btn-closebtn custom-button"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewConversation;
